import { Box, CircularProgress, Typography } from '@mui/material';

const LoaderPage = () => {
    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh" width="100vw" position="fixed" top={0} left={0} zIndex={1300} bgcolor="background.default">
            <Box textAlign="center">
                <CircularProgress size={60} />
                <Typography variant="h6" fontWeight="bold" mt={2}>
                    Loading...
                </Typography>
            </Box>
        </Box>
    );
};

export default LoaderPage;